import { DetailsPerUserReport, SummaryReport, MediaSpecificUserUsageWithDuration } from '../types/NewReport';
import { Report, ReportTypes } from '../types';
import { api } from './api';
import { AxiosResponse } from 'axios';

const API_PATHS = Object.freeze({
  reports: {
    summary: '/reports/summary',
    otavaSummary: '/reports/summary/otava',
    detailsPerUser: '/reports/details-per-user',
    mediaSpecificUsers: '/reports/media-specific-users',
    reports: '/reports',
    type: '/reports/{type}',
    csv: '/reports/csv/{type}/{year}',
  },
});

export const getSingleReport = (type: ReportTypes): Promise<Report> =>
  api.get(API_PATHS.reports.type.replace('{type}', type.toString()), {});

export const getSingleReportCsv = (type: ReportTypes, targetYear: number): Promise<AxiosResponse> =>
  api.get(API_PATHS.reports.csv.replace('{type}', type.toString()).replace('{year}', targetYear?.toString()), {
    headers: {
      responseType: 'blob',
      'Content-Type': 'text/csv',
    },
  });

export const getSummaryReport = async (
  startDate: string,
  endDate: string,
  groupBy: 'media' | 'user',
  mediaType?: string,
  timeTrackedOnly?: boolean
): Promise<SummaryReport> => {
  const params = new URLSearchParams({
    startDate,
    endDate,
    groupBy,
  });
  if (mediaType) {
    params.append('mediaType', mediaType);
  }
  if (timeTrackedOnly) {
    params.append('timeTrackedOnly', 'true');
  }
  const response = await api.get(`${API_PATHS.reports.summary}?${params.toString()}`);
  return response.data;
};

export const getOtavaSummaryReport = async (
  startDate: string,
  endDate: string,
  mediaType?: string,
  timeTrackedOnly?: boolean
): Promise<SummaryReport> => {
  const params = new URLSearchParams({
    startDate,
    endDate,
  });
  if (mediaType) {
    params.append('mediaType', mediaType);
  }
  if (timeTrackedOnly) {
    params.append('timeTrackedOnly', 'true');
  }
  const response = await api.get(`${API_PATHS.reports.otavaSummary}?${params.toString()}`);
  return response.data;
};

export const getDetailsPerUserReport = async (
  startDate: string,
  endDate: string,
  userId: number,
  timeTrackedOnly?: boolean,
  mediaType?: string
): Promise<DetailsPerUserReport> => {
  const params = new URLSearchParams({
    startDate,
    endDate,
    userId: userId.toString(),
  });
  if (timeTrackedOnly) {
    params.append('timeTrackedOnly', 'true');
  }
  if (mediaType) {
    params.append('mediaType', mediaType);
  }
  const response = await api.get(`${API_PATHS.reports.detailsPerUser}?${params.toString()}`);
  return response.data;
};

export const getMediaSpecificUserUsage = async (
  startDate: string,
  endDate: string,
  mediaId: number,
  mediaType: string,
  timeTrackedOnly?: boolean
): Promise<MediaSpecificUserUsageWithDuration> => {
  const params = new URLSearchParams({
    startDate,
    endDate,
    mediaId: mediaId.toString(),
    mediaType,
  });
  if (timeTrackedOnly) {
    params.append('timeTrackedOnly', 'true');
  }
  const response = await api.get(`${API_PATHS.reports.mediaSpecificUsers}?${params.toString()}`);
  return response.data;
};
